module.exports = __webpack_public_path__ + "static/img/hdywm.a365f0d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/hdywm.jpeg
// module id = BRZd
// module chunks = 0